import { ManagersModuleBase } from "Managers/ManagersModuleBase";
import { AddStudentViewModel } from "../AddStudentViewModel";
import { APIManager } from "./APIManager";
import { CommandsManager } from "./CommandsManager";
import { DomainManager } from "./DomainManager";
import { MobXManager } from "./MobXManager";

export class ManagersModule extends ManagersModuleBase<AddStudentViewModel> {
    public api!: APIManager;
    public commands!: CommandsManager;
    public domain!: DomainManager;
    public mobx!: MobXManager;

    constructor(viewModel: AddStudentViewModel) {
        super(viewModel);
        this.createManagers();
    }

    protected createManagers(): void {
        this.mobx = new MobXManager(this.viewModel);
        this.api = new APIManager(this.viewModel);
        this.domain = new DomainManager(this.viewModel);
        this.commands = new CommandsManager(this.viewModel);
    }
}
